export const MESSAGES = "MESSAGES";
export const SENDMESSAGE = "SENDMESSAGE";
export const JOINCHAT = "JOINCHAT";
export const CHATROOMS = "CHATROOMS";

export const getallmsgs = () => {
  return {
    type: MESSAGES
  };
};

export const sendmsg = msg => {
    return {
      type: SENDMESSAGE,
      payload:msg
    };
};

export const joinchat = data => {
  return {
    type: JOINCHAT,
    payload:data
  };
};

export const getalljoinrooms = () => {
  return {
    type: CHATROOMS
  };
};

